import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { InterviewTemplatesHttpService } from '../interview-templates-http.service';
import { actions } from './interview-template-details.store';

@Injectable()
export class InterviewTemplateDetailsEffects {
  public effect = createEffectFactory(actions, this.actions$);

  public fetchOne = this.effect(actions.fetchOne, ({ payload: { id } }) =>
    this.interviewTemplatesHttpService
      .fetchOne({ id: <number>id })
      .pipe(map(data => ({ data: data.interviewTemplate }))),
  );

  public create = this.effect(actions.createOnePessimistic, ({ payload: { data } }) =>
    this.interviewTemplatesHttpService
      .create(data)
      .pipe(map(data => ({ data: data.interviewTemplate }))),
  );

  public delete = this.effect(actions.removeOnePessimistic, ({ payload: { data: id } }) =>
    this.interviewTemplatesHttpService
      .delete(<number>id)
      .pipe(map(data => ({ data: data.interviewTemplate }))),
  );

  public update = this.effect(actions.updateOnePessimistic, ({ payload: { data } }) =>
    this.interviewTemplatesHttpService
      .update(data.id, data)
      .pipe(map(data => ({ data: data.interviewTemplate }))),
  );

  public duplicate = this.effect(actions.duplicate, ({ payload: { id, correlationId } }) =>
    this.interviewTemplatesHttpService.duplicate(id).pipe(
      switchMap(data =>
        of(
          actions.duplicateSuccess({
            payload: { sourceId: id, data: data.interviewTemplate, correlationId },
          }),
        ),
      ),
      catchError(error =>
        of(actions.duplicateFailed({ payload: { sourceId: id, error, correlationId } })),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private interviewTemplatesHttpService: InterviewTemplatesHttpService,
  ) {}
}
